import { getBankPortalLayout } from 'commons/service/bank/layout'
import { GetBankPortalLayoutResponse } from 'commons/types/DTO/bank/layout'
import { Keys, ReadHook, useStateManager } from 'state-manager'

export const useGetBankPortalLayout: ReadHook<GetBankPortalLayoutResponse> = () =>
  useStateManager().use(Keys.BankPortal.Layout, getBankPortalLayout)
